import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as authActions from 'action/auth'
import { translate } from 'react-i18next'
import NewLoginForm from 'component/auth/NewLoginForm'
import Modal from 'component/Modal/GenericModal'
import './styles.css'
import LogoWithoutDesc from 'images/logo-without-desc.svg'
import User from '../../../utils/User'
import API_URL from 'constants/api'

const NewLogin = (props) => {
  NewLogin.propTypes = {
    loginUser: PropTypes.func.isRequired,
    fetchPingIdParameter: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    error: PropTypes.object,
    systemParametersReducer: PropTypes.object,
    message: PropTypes.string
  }

  const { translate, error, loginUser, fetchPingIdParameter } = props

  const [environmentTranslationKey, setEnvironmentTranslationKey] = useState('')

  useEffect(() => {

    const environment = process.env.API_ENV
    switch (environment) {
      case 'homologation':
        setEnvironmentTranslationKey('application.environment.homologate')
        break
      case 'production':
        setEnvironmentTranslationKey('production')
        break
      default:
        setEnvironmentTranslationKey('application.environment.developer')
        break
    }
  }, [])

  useEffect(() => {
    // Mostrar modal por 1 segundo e depois deslogar após houver erro ao logar por ping sem missão
    if(error && error.cdStatus === 401 && error.dsMessage === "Erro na autenticação") {
      setTimeout(() => {
        const user = new User()
        user.clearCache()
        window.location.replace(API_URL.PING_LOGOUT)
      } , 1000)
    }
  })

  const handleErrorModal = (message) => {
  if (
    message.dsMessage === 'Nome de usuário ou senha incorretos.' || 
    message.dsMessage === 'Usuário sem perfil de acesso cadastrado'
  ) {
    const confirmButtonText = message.dsMessage === 'Login expired due to inactivity.' ? 'Ok' : translate('newLogin.errorModal.button.label')

      return (
        <Modal
          className='new-login-error-modal'
          title={translate('newLogin.errorModal.title')}
          size='sm'
          isOpen
          disabledBgClickClosing
          hideCancelButton
          buttonClass='new-login-error-modal-button'
          confirmButtonText={confirmButtonText}
        >
          <div>
          {message.dsMessage === 'Nome de usuário ou senha incorretos.'
              ? translate('newLogin.errorModal.message')
              : translate('newLogin.errorModal.incorrectCredentialsMessage')}      
          </div>
        </Modal>
      )
    }
  }
  return (
    <section className='container-login-new'>
      <div className='top-login-banner'>
        <div className='welcome'>
          <p>{translate('newLogin.welcome')}</p>
        </div>
        <div className='welcomeMessage'>
          <p>{translate('newLogin.welcomeMessage')}</p>
        </div>
      </div>
      <div className='middle-login-banner'>
        <img className='new-header-logo' src={LogoWithoutDesc} />
        <span />
        <div className='middle-login-banner-right-side'>
          <p>{translate('mobile.portal-name')}</p>
          {environmentTranslationKey !== 'production' && (
            <div>
              <p>{translate(environmentTranslationKey)}</p>
            </div>
          )}
        </div>
      </div>
      <div className='form-container'>
        <NewLoginForm
          error={error}
          translate={translate}
          loginUser={loginUser}
          fetchPingIdParameter={fetchPingIdParameter}
        />
      </div>
      {error && error.cdStatus === 401 && error.dsMessage === 'Erro na autenticação' && handleErrorModal(error) || error && handleErrorModal(error.message)}
    </section>
  )
}

const mapStateToProps = ({ auth }) => ({
  error: auth.error
})
/**
 * Maps actions and dispatch them to props
 * @param {Function} dispatch
 * @return {Object} props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(authActions, dispatch)
/* istanbul ignore next */
const NewLoginTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(NewLogin)

export default connect(mapStateToProps, mapDispatchToProps)(NewLoginTranslated)

export { NewLogin }
